var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 9.0188C16.5 4.86842 13.14 1.5 9 1.5C4.86 1.5 1.5 4.86842 1.5 9.0188C1.5 12.6579 4.08 15.688 7.5 16.3872V11.2744H6V9.0188H7.5V7.1391C7.5 5.68797 8.6775 4.50752 10.125 4.50752H12V6.76316H10.5C10.0875 6.76316 9.75 7.1015 9.75 7.51504V9.0188H12V11.2744H9.75V16.5C13.5375 16.1241 16.5 12.9211 16.5 9.0188Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLight);
export default __webpack_public_path__ + "static/media/Facebook-light.8d75c7a9231a56fcc69bc9174eba11a2.svg";
export { ForwardRef as ReactComponent };